import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Load the saved theme from localStorage
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute("data-theme");
    const newTheme = currentTheme === "light" ? "dark" : "light";

    // Update the theme
    document.documentElement.setAttribute("data-theme", newTheme);

    // Save the user's preference
    localStorage.setItem("theme", newTheme);
  }
}
